import React from 'react';
import { parseStat, useCountUp } from './useCountUp';
/** A single hero stat that counts up on mount (numeric ones) then shows suffix. */
export function Stat({
  value,
  label,
  start
}: {
  value: string;
  label: string;
  start: boolean;
}) {
  const {
    num,
    prefix,
    suffix
  } = parseStat(value);
  const count = useCountUp(num ?? 0, start && num !== null);
  return <div data-id="element-315" data-mp="2yh6fv63dcdm2">
      <dd className="font-display text-[34px] font-light leading-none text-white tabular-nums" data-id="element-316" data-mp="3m9d3ngv13c9v">
        {num === null ? value : `${prefix}${count}${suffix}`}
      </dd>
      <dt className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-stone-500" data-id="element-317" data-mp="3r63v10ca9ual">
        {label}
      </dt>
    </div>;
}